export default __webpack_public_path__ + "static/media/quickiememe.f2b567d4.png";